// 钉钉微应用实名认证 (saas有个人账号，快速绑定)
<template>
  <no-ssr>
    <div class="ding-auth-sty">
      <h1 class="font-red">账号绑定</h1>
      <div class="auth-content">
        <h3 class="titleII">
          <span class="title-icon"></span>
          个人实名认证
        </h3>
        <el-form ref="bandFormRef" :model="bandForm" :rules="rules" class="band-form-sty">
          <el-form-item prop="mobile">
            <el-input v-model="bandForm.mobile" placeholder="请输入手机号" :style="{width:inputWidth}"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input placeholder="请输入验证码" v-model="bandForm.code" :style="{width:inputWidth}">
              <el-button slot="append" class="append-sty" @click.prevent="getImgCode" :disabled="codeCount > 0">{{codeCount > 0 ? codeCount + 'S':'获取验证码'}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="isInDingTalk" style="width:158px;" @click="$router.replace({ path: '/login/middle' })">选择其他认证方式</el-button>
            <el-button type="primary" style="width:158px;" @click="bandAuthBy">立即绑定</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 图形验证码弹窗 -->
      <el-dialog title="提示" :visible.sync="imgCodeVisi" width="30%" :close-on-click-modal="false">
        <el-input
          v-model="bandForm.code_copy"
          class="input-width"
          auto-complete="off"
          placeholder="输入图形验证码"
        >
          <template slot="append">
            <span class="img-code" @click="getImgCode">
              <img :src="'data:image/png;base64,' + imgAuth.imgPath" />
            </span>
          </template>
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="imgCodeVisi = false">取 消</el-button>
          <el-button type="primary" @click="getRegistCode">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </no-ssr>
</template>
<script>
import { mobile } from "@/assets/js/lib/valid-methods";
import { dingtalkApi } from '@/assets/js/http-serve/dingtalkApi';
import { isInDingTalk } from "@/assets/js/utils/ding-env";

// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用
let dd = null;
if (process.client) {
  dd = require('dingtalk-jsapi');
}

export default {
  layout: 'fullpage',
  data () {
    // 这里存放数据
    return {
      isInDingTalk,
      codeCount:0,
      loginInfo: { dingTalkCorpName: '' },
      imgCodeVisi: false,
      inputWidth: '460px',
      imgAuth: '',
      bandForm: {
        mobile: '',
        code: '',
        code_copy: ''
      },
      // 签署设置
      rules: {
        mobile: [{ validator: mobile, trigger: "change" }],
        code: [{ required: true, message: '请输入验证码', trigger: 'change' }],
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 立即绑定 */
    bandAuthBy () {
      this.$refs.bandFormRef.validate((valid) => {
        if (valid) {
          const { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo, { code, mobile } = this.bandForm, _this = this;
          const param = {
            dingTalkUserId,
            corpId,
            code,
            mobile
          };
          dingtalkApi.perReplenish(param).then(res => {
            if (!res.success) {
              if (res.code == '10502') return _this.$message.error(res.description)
              _this.$confirm(
                res.description, '提示',
                {
                  distinguishCancelAndClose: true,
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: "前往认证",
                  cancelButtonText: "更换账号",
                  type: "warning"
                }
              ).then(() => {
                _this.$router.push({ path: '/dingtalkUse/personAuth' })
              })
              return
            }
            if (res.data.identityAuth == 1) this.$message.success('认证成功！')
            // 跳转中间页，重新获取信息
            this.$router.replace({ path: '/login/middle',query:{corpId} })
          })
        }
      });
    },
    /** 120s 倒计时 */
    countDown (count) {
      const _this=this;
      _this.codeCount=count;
      let timer = setInterval(() => {
        if (_this.codeCount == 0) {
          clearInterval(timer);
          _this.codeCount=0;
        }else{
          -- _this.codeCount;
        }
      }, 1000);
    },
    /** 获取验证码 */
    getRegistCode () {
      const _this = this, { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo;
      if (!_this.bandForm.mobile) return this.$message.warning('请输入手机号码')
      if (!_this.bandForm.code_copy) return this.$message.warning('请输入图形验证码')
      const param = {
        corpId,
        dingTalkUserId,
        imageCode: _this.imgAuth.imgToken + "_" + _this.bandForm.code_copy,
        targetId: _this.bandForm.mobile
      }
      dingtalkApi.registerCodeSend(param).then(res => {
        if (!res.success) {
          if(res.code === '10506'){
            const {num} = res.data;
            if(num) _this.countDown(num);
          }
          return _this.$message.error(res.description)
        }
        _this.countDown(120);
        _this.$message.success('已发送验证码，请注意查收')
      }).finally(() => { this.imgCodeVisi = false })
    },
    /** 获取图形验证码 */
    getImgCode () {
      const _this = this;
      _this.$refs.bandFormRef.validateField(['mobile'], (valid) => {
        if (!valid) {
          const corpId = sessionStorage.getItem("corpId"),
            { dingTalkUserId } = _this.loginInfo;
          let param = {
            corpId,
            dingTalkUserId
          };
          dingtalkApi.getImgCode(param).then(({ data }) => {
            _this.bandForm.code_copy = ''
            _this.imgAuth = data;
            _this.imgCodeVisi = true
          });
        }
        // 验证end
      })
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // dd.ready 已移至 mounted，mounted 只在客户端执行，避免 SSR 调用钉钉 API
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    if (dd) {
      dd.ready(() => {
        const session = sessionStorage;
        this.loginInfo = JSON.parse(session.getItem("dingloginInfo"));
      })
    }
  },
}
</script>

<style lang='less' scoped>
@import (less) "../../../../assets/style/cssVariable.less"; // 引入公共css类
.ding-auth-sty {
  width: 75vw;
  height: 90vh;
  padding-top: 20px;
  margin: 0 auto;
  background-color: @ebq-white;
  .font-red {
    color: @ebq-red;
  }
  h1 {
    text-align: center;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .auth-content {
    width: 60vw;
    margin: 0 auto;
    .append-sty {
      color: @ebq-white;
      background-color: @ebq-red;
      border-color: @ebq-red;
    }
    .band-form-sty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .auth-band {
      display: block;
      margin: 0 auto;
      width: 20vw;
      margin-top: 10vh;
    }
  }
  .titleII {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin: 10vh 0;
  }
  .title-icon {
    display: inline-block;
    width: 5px;
    height: 15px;
    margin-right: 10px;
    background-color: @ebq-title-icon-color;
  }
  .img-code {
    background-color: #fff;
    display: inline-block;
    margin: 0 -20px;
    width: 100px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    img {
      vertical-align: middle;
      display: inline-block;
      height: 38px;
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// pages/auth/dingTalkAuthComponents/personAuth/saasPersonBand.vue